import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { UilArrowLeft, UilArrowRight } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';


const StyledSlider = styled(Slider)`
  margin-bottom: 50px;
  > .slick-dots li {
    width: 8px;
    height: 8px;
    padding: 0px;
    background: #C4C4C4;
    border-radius: 4px;
  }

  > .slick-dots li button:before {
    display: none;
  }

  > .slick-dots li.slick-active {
    background: #686766;
  }

  > svg {
    @media only screen and (max-width: 767px) {
      display: none !important;
    }
  }
`;

const Card = styled.div`
  padding-top: 26px;
  padding-bottom: 25px;
  .process-image {
    width: 400px;
    margin: 0 auto 27px;
    @media only screen and (max-width: 767px) {
      width: 320px;
    }
  }
  .process-text {
    margin: 0 auto;
  }
  .process-number {
    margin: 0 auto 25px;
    width: 26px;
  }
`;

export const SliderVentajas = (props) => {
  const { t , i18n } = useTranslation('global');
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

 const Processes = [
  {
    id: 0,
    image: i18n.language === 'en'
      ? 'https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2FVENTAJAS%20AXIONA-INGLE%CC%81S1.png?alt=media&token=ed78ec4a-96ca-4390-9f98-813f248230fb'
      : 'https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2FVENTAJAS%20AXIONA-ESPAN%CC%83OL1.png?alt=media&token=51343686-6724-42ae-a474-ccbcda73cd49',
    text: i18n.language === 'en'
      ? 'URL_TEXTO_EN_0'
      : 'URL_TEXTO_ES_0',
    textWidth: '78px',
    label: t('doctors.why-axiona.process.list.1.desc'),
  },
  {
    id: 1,
    image: i18n.language === 'en'
      ? 'https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2FVENTAJASINGLES2.png?alt=media&token=e16f64cc-ad6c-4232-bae2-d9b22473a502'
      : 'https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2FVENTAJAS%20AXIONA-ESPAN%CC%83OL2.png?alt=media&token=fc857f96-4f44-4264-b301-b1bc9900d808',
    text: i18n.language === 'en'
      ? 'URL_TEXTO_EN_1'
      : 'URL_TEXTO_ES_1',
    textWidth: '104px',
    label: t('doctors.why-axiona.process.list.2.desc'),
  },
  {
    id: 2,
    image: i18n.language === 'en'
      ? 'https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2FVENTAJAS%20AXIONA-INGLE%CC%81S3.png?alt=media&token=f02cf67b-137b-4abb-8288-3145b2384856'
      : 'https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2FVENTAJAS%20AXIONA-ESPAN%CC%83OL3.png?alt=media&token=e458ba2b-f40d-4253-a6da-7583570a8393',
    text: i18n.language === 'en'
      ? 'URL_TEXTO_EN_2'
      : 'URL_TEXTO_ES_2',
    textWidth: '137px',
    label: t('doctors.why-axiona.process.list.3.desc'),
  },
];


  function handleWindowSizeChange() {
    setScreenWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <UilArrowLeft
        width={40}
        className={className}
        style={{ ...style, display: 'block', color: '#1C3245' }}
        onClick={onClick}
      />
    );
  }
  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <UilArrowRight
        className={className}
        style={{ ...style, display: 'block', color: '#1C3245' }}
        onClick={onClick}
      />
    );
  }

  return (
    <>
    <h2 style={{color:"#003A5D", textAlign: "left", fontWeight:"600"}} className="mb-4">{t('doctors.why-axiona.process.title')}</h2>
    <StyledSlider
      dots={true}
      infinite={true}
      slidesToShow={
        screenWidth > 1199
          ? 3
          : 1
      }
      slidesToScroll={
        screenWidth > 1199
          ? 1
          : 1
      }
      autoplay={true}
      autoplaySpeed={4000}
      cssEase={'linear'}
      speed={600}
      prevArrow={<PrevArrow />}
      nextArrow={<NextArrow />}
    >
      {Processes.map((process, index) => (
        <Card>
          <img alt={`imagen-${index}`} src={process.image} className="process-image" />
        </Card>
      ))}
    </StyledSlider>
    </>
  );
};
